module.exports = __webpack_public_path__ + "img/protection.61679f65.jpg";